<template>
  <div class="absolute mx-2" :style="css">
    <div
      class="bg-marine flex flex-col items-center rounded py-2 px-4 right-0 bottom-full z-50"
    >
      <p class="text-white z-50" :class="fontClass">{{ message }}</p>
      <div class="bg-marine polygon" :class="position"></div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Tooltip',
  props: {
    position: {
      type: String,
      default: 'bottom',
    },
    message: {
      type: String,
      default: 'Loading...',
    },
    css: {
      type: String,
      default: '',
    },
    fontClass: {
      type: String,
      default: 'text-sm',
    },
  },
};
</script>

<style lang="scss" scoped>
.polygon.bottom {
  position: absolute;
  border-radius: 4px;
  bottom: -6px;
  width: 16px;
  height: 16px;
  z-index: 1;
  transform: rotate(45deg);
}

.polygon.top {
  position: absolute;
  border-radius: 4px;
  bottom: 20px;
  width: 16px;
  height: 16px;
  z-index: 1;
  transform: rotate(45deg);
}
</style>
